import { generatePath, useNavigate } from 'react-router-dom'

import { InceptionTypeInputEnum } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import useSessionUser from '@/modules/access/hooks/useSessionUser'
import { useCreateProduct } from '@/modules/admin-center/hooks/useCreateProduct'
import { useCreateOrUpdatePartyProduct } from '@/modules/products/hooks/useCreateOrUpdatePartyProduct'
import useCreateReceivingDocumentLineItem from '@/modules/receiving-notes/hooks/useCreateReceivingDocumentLineItem'
import { CreateProductFormInputs } from '@/modules/shared/components/create-product-modal/CreateProductFormSchema'
import { UseCreateAndAddProductProps } from '@/modules/shared/components/create-product-modal/hooks/useCreateAndAddProductRequisition'
import usePurchaseOrderId from '@/modules/shared/hooks/params/usePurchaseOrderId'
import { useAlert } from '@/modules/shared/hooks/useAlert'

export function useCreateAndAddProductGRNote({ id }: UseCreateAndAddProductProps) {
  const { currentOrganisation } = useSessionUser()
  const purchaseOrderId = usePurchaseOrderId()
  const [createProduct, { loading: createProductLoading }] = useCreateProduct()
  const [createReceivingDocumentLineItem, { loading: createReceivingDocumentLineLoading }] =
    useCreateReceivingDocumentLineItem()
  const navigate = useNavigate()
  const { alertDialog } = useAlert()
  const [createOrUpdatePartlyProduct] = useCreateOrUpdatePartyProduct()

  const onCreateAndAddProductGRNote = (input: CreateProductFormInputs, isAPurchaser?: boolean) => {
    const {
      categoryId,
      brand,
      itemDescription,
      unitPrice,
      quantity,
      itemMeasure,
      itemSize,
      itemPackName,
      itemSellPackName,
      itemSellQuantity,
      code,
      externalId,
    } = input
    createProduct({
      variables: {
        input: {
          categoryId,
          brand,
          itemDescription,
          locale: 'en',
          itemMeasure,
          itemSize,
          itemPackName: itemPackName === 'null' ? null : itemPackName,
          itemSellPackName,
          itemSellQuantity,
          externalId,
          inceptionType: InceptionTypeInputEnum.Manual,
          ownerCode: isAPurchaser ? code : undefined,
        },
      },
      onCompleted: async (data) => {
        const createdProductId = Number(data.createProduct.product?.id)
        if (code) {
          await createOrUpdatePartlyProduct({
            variables: {
              input: {
                productId: createdProductId,
                organisationId: Number(currentOrganisation?.id),
                code: code,
              },
            },
          })
        }
        createReceivingDocumentLineItem({
          variables: {
            input: {
              receivingDocumentId: Number(id),
              productId: createdProductId,
              quantity: Number(quantity),
              overrideUnitValue: unitPrice,
            },
          },
          onCompleted: () => {
            navigate(
              generatePath('/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/draft/summary', {
                receivingNoteId: String(id),
                purchaseOrderId: String(purchaseOrderId),
              })
            )
          },
        })
      },
      onError() {
        alertDialog({ type: 'error' })
      },
    })
  }

  return {
    onCreateAndAddProductGRNote,
    loading: createProductLoading || createReceivingDocumentLineLoading,
  }
}
